module.exports = __webpack_public_path__ + "7ad2abfea964baad6ba7429be5b3d01f.MP3";